module.exports = __webpack_public_path__ + "static/img/2.3925ce5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/case/2.png
// module id = 955t
// module chunks = 0